import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useMemo } from 'react';
export const SchemaDefinitionsContext = createContext({
    definitions: {},
    omitFields: [],
});
export const SchemaDefinitionsProvider = ({ schema, omitFields, children }) => {
    const value = useMemo(() => {
        var _a;
        const definitions = (_a = schema.definitions) !== null && _a !== void 0 ? _a : {};
        return { definitions, omitFields };
    }, [omitFields, schema.definitions]);
    return _jsx(SchemaDefinitionsContext.Provider, { value: value, children: children });
};
//# sourceMappingURL=SchemaDefinitionsProvider.js.map